import "./WhoWeAre.css";
import placeholderImg from "../assets/placeholder-image.png";

function WhoWeAre() {
  return (
    <section className="who">
      <div className="who-container">
        <div className="who-text">
          <h2 >Who We Are</h2>
          <p>
            Dhara Foundation was born from a deep belief that growth should not 
            be measured only in profits, but in the positive impact we create for society. 
            As industries grow, the responsibility to protect nature and up lift communities 
            grows with them. We realized that many organizations want to contribute meaningfully 
            but need a trusted partner to translate their CSR vision into real action. Dhara 
            Foundation was created to bridge this gap 
            turning compassion into structured, measurable change
          </p>
        </div>

        {/* ✅ Image added here */}
    <div className="who-image">
      <img src={placeholderImg} alt="Who We Are" />
    </div>
      </div>
    </section>
  );
}

export default WhoWeAre;